import React from 'react'

export default function AreaIcon({ color = null }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color }}
    >
      <path
        d="M15.294 0v1.176H4.706V0H0v4.707h1.176v10.588H0V20h4.706v-1.176h10.588V20H20v-4.705h-1.175V4.707H20V0h-4.706zM2.354 4.707h2.352V2.353h10.588v2.354h2.354v10.588h-2.354v2.352H4.706v-2.352H2.353V4.707z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}
